import _ from 'lodash';
import { ViewModelUtil } from '@xengage/gw-portals-viewmodel-js';

const visibilityProperty = _.property('aspects.visible');
const METADATA_CLASS_TWIA = 'org.twia.edge.aspects.validation.dto.TWIANotVisibleRuleDTO';

/**
 * TWIACleanseObj
 */
export default class TWIACleanseObj {

    /**
     * This function iterates through the object recursively and sets values of all properties, whose aspects.visible is false.
     * @param {viewModel} obj
     */
    static resetAspectsNotVisibleValues(obj) {
        _.forOwn(obj, (value, key) => {
            const isValueViewModel = ViewModelUtil.isViewModelNode(value);

            if (typeof value === 'object' && isValueViewModel) {
                const isVisible = visibilityProperty(value);
                // DE13216 for TWIA visibility items, allow the data to pass through
                const isNotSetMetadata = value._metadataInfo.elementMetadata.get(METADATA_CLASS_TWIA);
                const isNotSet = isNotSetMetadata && isNotSetMetadata.length > 0;

                if (isVisible === false && isNotSet === false) {
                    // Uncomment below to log the fields being reset.
                    // console.info(`Setting <${key}> to undefined as aspects.visible is false`);
                    // eslint-disable-next-line no-param-reassign
                    value.value = undefined;
                }

                this.resetAspectsNotVisibleValues(value);
            }
        });
    }
}
